import {SetOperations} from './SetOperations';

export class ArrayOperations {
  public static union<T>(arrayA: T[], arrayB: T[]): T[] {
    return Array.from(SetOperations.union(new Set(arrayA), new Set(arrayB)));
  }

  public static difference<T>(arrayA: T[], arrayB: T[]): T[] {
    return Array.from(SetOperations.difference(new Set(arrayA), new Set(arrayB)));
  }

  public static uniq<T>(array: T[]): T[] {
    return Array.from(new Set(array));
  }

  // генерирует массив упорядоченных чисел от start до stop включительно
  // range(1, 5, 1)) => [1,2,3,4,5]
  public static range(start: number, stop: number, step: number = 1): number[] {
    return Array.from(
      {length: Math.floor((stop + 1 - start) / Math.abs(step))},
      (value, index) => start + index * Math.abs(step),
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static clear(array: any[]): void {
    array.splice(0, array.length);
  }

  public static last<T>(array: T[]): T | undefined {
    return array[array.length - 1];
  }

  public static first<T>(array: T[]): T | undefined {
    return array[0];
  }
}
